module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_3016.bd643eda.png";